/* eslint-disable typescript-sort-keys/string-enum */
export enum ModalSize {
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}
/* eslint-enable typescript-sort-keys/string-enum */
